import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import { IffShipmentSummaryService } from 'src/app/services/iff-shipment-summary/iff-shipment-summary.service';
import {ActivatedRoute, Router} from '@angular/router';
import {
  FRTIffShipmentDetailResponse,
  HHGIffShipmentDetailResponse,
  IFFShipmentSummaryResponse,
  PageResponse
} from 'src/app/shared/common-components/common-structure';
import {ColDef, ColGroupDef, GridApi, GridOptions, IDatasource, IGetRowsParams} from 'ag-grid-community';
import {BehaviorSubject, map, Observable} from 'rxjs';
import { IffShipmentDetailsService } from 'src/app/services/iff-shipment-details/iff-shipment-details.service';
import {CommonHelpers} from "../../../shared/common-helpers";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {AlertService} from "../../../services/alert/alert.service";
import {LoadingService} from "../../../services/loading/loading.service";
import {
  ConfirmationModalComponent
} from "../../../shared/common-components/confirmation-modal/confirmation-modal.component";
import {takeWhile} from "rxjs/operators";
import {DownloadFileResponse} from "../../../shared/common-components/file-storage/downloadFileResponse";
import * as FileSaver from "file-saver";
import {
  api_error, carrier_user, carrier_user_admin, carrier_user_paygov,
  frt_iff_download_success,
  hhg_iff_download_success, system_admin
} from "../../../shared/common-components/AppConstants";
import {PayShipmentInvoicesModalComponent} from "../pay-shipment-invoices-modal/pay-shipment-invoices-modal.component";
import moment from "moment/moment";
import {UserService} from "../../../services/user/user.service";
import {User} from "../../../services/user/user";

@Component({
    selector: 'app-hhg-quarterly-reports',
    templateUrl: './hhg-quarterly-reports.component.html',
    styleUrls: ['./hhg-quarterly-reports.component.css'],
    standalone: false
})
export class HhgQuarterlyReportsComponent implements OnInit {
  disableSelect = true;
  private observer$ = new BehaviorSubject(true);
  private isNoRowSelectedEvent$ = new BehaviorSubject(true);
  isNoRowSelected$ = this.isNoRowSelectedEvent$.asObservable();
  gridOptions: GridOptions;
  gridOptionsApi: any;
  detailGridOptions: GridOptions;
  modalRef: BsModalRef;
  frameworkComponents: any;
  iffMasterId: number;
  endRoute: String;
  currentUser: User | any;

  title: string = 'Administrative Fee (AF) Payments';
  IFFShipmentPaginationResults$: Observable<PageResponse<IFFShipmentSummaryResponse>> = this.iffShipmentSummaryService.HHGShipmentResults$.pipe(
    map((t: any) => {
      if (t.content !== null && t.content !== undefined && t.content.length > 0) {
        return CommonHelpers.sortAtoZByYearByQtr(t.content);
      }
    })
  )
  private gridApi!: GridApi<any>;


  IffShipmentSummaryColumnDefs: (ColDef | ColGroupDef)[] = [
    <ColDef>{
      checkboxSelection: (params) => {
        // enable checkbox for unpaid and non-zero payments
        return params.data && params.data.paymentStatus === 'Unpaid' && Number(params.data.totalIFF) > 0 && !this.disableSelect;
      },
      width: 50
    },
    {
      headerName: 'SCAC Code',
      field: 'scac',
      filter: 'agTextColumnFilter',
      sortable: true,
      width: 80
    },
    {
      headerName: 'TSP Name',
      field: 'scacName',
      filter: 'agTextColumnFilter',
      sortable: true, chartDataType: 'series'
    },
    {
      headerName: 'Reporting Year',
      field: 'reportingYear',
      filter: 'agTextColumnFilter',
      sortable: true, chartDataType: 'series',
      width: 120
    },
    {
      headerName: 'Reporting Quarter',
      field: 'reportingQuarter',
      filter: 'agTextColumnFilter',
      sortable: true, chartDataType: 'series',
      width: 120
    },
    {
      headerName: 'Move Type',
      field: 'moveType',
      width: 80,
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Type of Transportation',
      field: 'transportationType',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Net Amount',
      field: 'netAmount',
      filter: 'agTextColumnFilter',
      sortable: true,
      width: 80,
      valueGetter: (params) => params.data.netAmount,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.currencyComparator
    },
    {
      headerName: 'Total AF Owed',
      field: 'totalIFF',
      filter: 'agTextColumnFilter',
      sortable: true,
      width: 80,
      valueGetter: (params) => params.data.totalIFF,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.numberComparator
    },
    {
      headerName: 'Pay.gov Payment Status',
      field: 'paymentStatus',
      filter: 'agTextColumnFilter',
      sortable: true,
      width: 80,
      valueGetter: params => {
        if (params.data.totalIFF === "0.00") {
          return '';
        } else if (params.data.paymentStatus === 'Success' || params.data.paymentStatus === 'Received' || params.data.paymentStatus === 'Waiting' || params.data.paymentStatus === 'Submitted') {
          return 'Pending';
        } else if (params.data.paymentStatus === 'Settled' || params.data.paymentStatus === 'Reconciled') {
          return 'Accepted';
        } else if (params.data.paymentStatus === 'Failed' || params.data.paymentStatus === 'Cancelled' || params.data.paymentStatus === 'Retired' || params.data.paymentStatus === 'Denied' || params.data.paymentStatus === 'Disputed' || params.data.paymentStatus === 'Unknown') {
          return 'Rejected';
        } else {
          return 'Unpaid';
        }
      },
      cellRenderer: params => {
    // Keep the cellRenderer for display purposes
      return params.value; // Use params.value, which is now the processed value from valueGetter
      }
    },
    {
      headerName: 'Pay.gov Payment Date',
      field: 'paymentDate',
      filter: 'agTextColumnFilter',
      valueGetter: (params) => {
        return params.data.paymentDate ? moment(params.data.paymentDate, "YYYY-MM-DD HH:mm:ss").format("MM-DD-YYYY hh:mm A") : '';
      },
      sortable: true,
      width: 80,
      comparator: this.iffShipmentSummaryService.dateComparator
    },
    {
      headerName: 'Pay.gov Date Posted',
      field: 'paymentReconciledDate',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueGetter: (params) => {
        return params.data.paymentReconciledDate ? moment(params.data.paymentReconciledDate, "YYYY-MM-DD HH:mm:ss").format("MM-DD-YYYY hh:mm A") : '';
      },
      comparator: this.iffShipmentSummaryService.dateComparator,
      width: 80,
    },
    {
      headerName: 'Pay.gov Tracking ID',
      field: 'paygovTrackingId',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'TMSS Tracking ID',
      field: 'tmssTrackingId',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Paid By',
      field: 'createdUser',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Payment Method',
      field: 'paymentMethod',
      filter: 'agTextColumnFilter',
      sortable: true
    },
  ];

  disableExport = false;

  constructor(private iffShipmentSummaryService: IffShipmentSummaryService,
              private alertService: AlertService, private loader: LoadingService,
              private modalService: BsModalService, private iffShipmentDetailsService: IffShipmentDetailsService,
              private router: Router, private route: ActivatedRoute, private userService: UserService) {
  }

  ngOnInit() {
    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(currentUser => {
        this.currentUser = currentUser;
        if (this.currentUser && this.currentUser.roles) {
          for (const role of this.currentUser.roles) {
            if (role.name === carrier_user_paygov || role.name ===  carrier_user_admin) {
              this.disableSelect = false;
              break;
            } else {
              this.disableSelect = true;
            }
          }
        }
        this.loader.hide();
      }, error => {
        this.loader.hide();
        this.alertService.info('unable to get current user details');
      });
    const token = this.route.snapshot.queryParamMap.get('token');
    console.log('Query parameter value:', token);
    if (token) {
      this.iffShipmentSummaryService.completePaygovTransaction(token).subscribe(res => {
        console.log(res);
        this.iffShipmentSummaryService.refreshQuarterlyReports();
        setTimeout(() => {
          if (this.gridOptionsApi) {
            this.gridOptionsApi.refreshCells({force: true});
            this.gridOptionsApi.redrawRows();
          }
        }, 500)
        if (res === "Success" || res === "Received" || res === "Waiting" || res === 'Submitted') {
          const currentPaginationReq = this.iffShipmentSummaryService.HHGShipmentResults$;
          this.alertService.information(`Your AF Payment has been submitted and is being reviewed by Pay.gov.  Once the review is completed, you will be notified of the payment status via email.  Please take any additional action, if needed, at that time.
          You can also come back to this page and check the status under "Payment Status" for updates.`);
        } else {
          this.alertService.error(res + "Please try after some time or use a different payment method.");
        }
      }, error => {
        this.alertService.error('An error occurred while completing the pay gov transaction');
      });
    }
    this.endRoute = this.router.url.substring(1);
    this.gridOptions = <GridOptions>{
      columnDefs: this.IffShipmentSummaryColumnDefs,
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: false
        }
      },
      masterDetail: true,
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      rowMultiSelectWithClick: true,
      suppressDragLeaveHidesColumns: true,
      detailCellRendererParams: {
        getDetailRowData: params => {
          this.loader.show();
          /*this.updateIFFShipmentDetailRequestFn(params.data['iffMasterId'])
            .pipe(takeWhile(() => this.observer$.value))
            .subscribe(results => {
              params.successCallback(results);
              this.loader.hide();
            }, error => this.loader.hide());*/
        }
      },
      isRowMaster: rowData => rowData ? rowData.numberOfShipments > 0 : false,
      onGridReady: params => {
        this.gridOptionsApi = params.api;
        params.api.sizeColumnsToFit();
        // params.api.setDatasource(this.getIFFShipmentQueryDataSource(this.updateIFFShipmentPaginationRequestFn,
        //   this.IFFShipmentPaginationResults$));
      },
      isRowSelectable: function(rowNode) {
        return rowNode.data.totalIFF !== "0.00";
      },
      onSelectionChanged: params => {
        const selectedRows = params.api.getSelectedNodes();
        if (selectedRows && selectedRows.length > 0) {
          this.isNoRowSelectedEvent$.next(false);
        } else {
          this.isNoRowSelectedEvent$.next(true);
        }
      },
      defaultExportParams: {
        getCustomContentBelowRow: params => {
          return [];
        }
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  onDelete() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, Do You Want to Delete this Shipment Report Record(s)?';
    this.modalRef.content.title = 'Deleting Shipment Reports';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.loader.show();
        const selectedRows = this.gridOptionsApi.getSelectedRows();
        this.iffShipmentSummaryService.deleteIffShipment(selectedRows.map(iff => +iff.iffMasterId))
          .subscribe(() => {
            this.loader.hide();
            this.alertService.success('Successfully Deleted Shipment Report Record');
            this.gridOptionsApi.updateRowData({remove: selectedRows});
          }, err => {
            this.loader.hide();
            this.alertService.error('There was an error deleting Shipment Report');
          });
      }
    });
  }

  payIffs() {
    const initialState = {
      selectedNodes: this.gridOptionsApi.getSelectedRows()
    }
    this.modalRef = this.modalService.show(PayShipmentInvoicesModalComponent,
      {initialState, backdrop: 'static', class: 'modal-lg' });
  }
}
